<template>
  <ReviewMetaSchema
    :itemprop="SCHEMA_ITEM_PROP.AGGREGATE_RATING"
    itemscope
    :itemtype="SCHEMA_ITEM_TYPE.AGGREGATE_RATING"
    :rating="rating"
    :reviews-count="reviewsCount"
  />
</template>

<script lang="ts">

import { SCHEMA_ITEM_PROP, SCHEMA_ITEM_TYPE } from '~~/constants/seo';

export default defineComponent({
  name: 'AggregateReviewSchema',

  props: {
    reviewsCount: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
  },
  setup() {

    return {
      SCHEMA_ITEM_PROP,
      SCHEMA_ITEM_TYPE,
    };
  
  },
});

</script>
